import { LifeBuoy, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

/**
 * Faixa fixa exibida apenas quando o Super Admin está em Modo Suporte dentro de
 * um tenant. Discreta o suficiente para não competir com a operação mas visível
 * para lembrar quem está operando. Botão para sair encerra a sessão no backend.
 */
export default function SupportBanner() {
  const { user, tenant, support, logout } = useAuth();
  if (!user?.support_mode) return null;
  const displayName = support?.tenant?.display_name || tenant?.display_name || tenant?.slug;
  const clientCode = support?.tenant?.client_code || tenant?.client_code;
  const exitSupport = async () => {
    await logout();
    toast.info("Sessão de suporte encerrada");
    window.location.replace("/super/clientes");
  };
  return (
    <div
      data-testid="support-banner"
      className="sticky top-0 z-50 border-b border-amber-300 bg-amber-100/95 backdrop-blur"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2 px-4 py-2 md:px-8">
        <div className="flex items-center gap-2 text-xs sm:text-sm font-semibold text-amber-900">
          <LifeBuoy size={14} />
          <span data-testid="support-banner-text">
            Modo Suporte · {displayName}{clientCode ? ` · Cliente #${clientCode}` : ""}
          </span>
        </div>
        <button
          data-testid="support-banner-exit"
          onClick={exitSupport}
          className="inline-flex items-center gap-1.5 rounded-full border border-amber-400 bg-white/70 px-3 py-1 text-[11px] font-semibold text-amber-900 hover:bg-white"
        >
          <LogOut size={12} /> Sair do modo suporte
        </button>
      </div>
    </div>
  );
}
